export function gnav() {
    const open = document.querySelector(".js-gnav_open");
    const close = document.querySelector(".js-gnav_close");

    const openfunc = () => {
        document.body.classList.add("-gnav_active");
        document.documentElement.classList.add("-lock"); //bodyだとwindowsで効かないのでhtmlにする
    };

    const closefunc = () => {
        document.body.classList.remove("-gnav_active");
        document.documentElement.classList.remove("-lock"); //bodyだとwindowsで効かないのでhtmlにする
    };

    open && open.addEventListener("click", openfunc);
    close && close.addEventListener("click", closefunc);

    //openfunc();
}
